import { orderTokenRequestOptions } from '@/utils/global/orderTokenHeaders'
import { fetchClient as fetch } from '@/api/fetch.config'
import axios from '@/api/axios.config'
import type {
  GetFuneralHomeNormalized,
  GetFuneralHomeLogoNormalized,
} from '@messenger/types'

export const getFuneralHome = async () => {
  const options = orderTokenRequestOptions()
  return (await fetch.get(
    `funeralHomes`,
    undefined,
    options,
  )) as GetFuneralHomeNormalized
}

export const getFuneralHomeById = async (funeralHomeId: string) => {
  return await axios.get<GetFuneralHomeNormalized>(
    `funeralHome/${funeralHomeId}`,
  )
}

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const createFuneralHome = async (payload: Record<string, unknown>) => {
  return await axios.post(`createFuneralHome`, payload)
}

// Serves as both an Admin and user endpoint. 😐
// As an Admin endpoint it requires the id parameter to find the home as a user endpoint it will take that from the user's details.
/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const updateFuneralHome = async (payload: Record<string, unknown>) => {
  return await axios.patch(`funeralHomes`, payload)
}

export const getFuneralHomeLogos = async () => {
  return await axios.get<GetFuneralHomeLogoNormalized | null>(
    `funeralHomeLogos`,
  )
}

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const createFuneralHomeLogo = async (size: unknown, file: unknown) => {
  return await axios.post(`createFuneralHomeLogo?size=${size}`, file, {
    headers: { 'content-type': 'form-data' },
  })
}

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const updateFuneralHomeLogo = async (
  logoId: string,
  size: unknown,
  file: unknown,
) => {
  return await axios.patch(`funeralHomeLogos/${logoId}?size=${size}`, file, {
    headers: { 'content-type': 'form-data' },
  })
}

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const getIpLocation = async () => {
  return await axios.get('iplocation')
}
